const APP_CONFIG = {
  version: "7.83.0",
  title: "Claire V7.83.0",
  version_client: "7.83.0",
};

export default APP_CONFIG;
